import { BaseCriterionSchemaProcessor } from './base-criterion-schema-processor';
import { updateOdataOptionsForDeviceCriterionDeviceName } from '../util/update-criterion-property-for-filter';

export class DeviceCriterionSchemaProcessor extends BaseCriterionSchemaProcessor {
  constructor(options) {
    super(options, ['Criterion/DeviceCriterion/DeviceName']);
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);
    updateOdataOptionsForDeviceCriterionDeviceName(odataOptions);

    return odataOptions;
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    if (this.Permissions.IsPersonalizedOffersEnabled &&
      !this.Permissions.IsPersonalizedOffersV3Enabled) {
      updatedSchema.properties.CriterionCashback = {
        filterable: true,
        type: 'number',
        minimum: 0,
        maximum: 50,
        required: true,
      };
    }

    return updatedSchema;
  }
}
